import {useAuthStore} from '../store/authStore';
import {useEffect, useRef} from 'react';

export function useAuth () {
  const {
    isAuthenticated,
    user,
    loading,
    error,
    initialized,
    login,
    logout,
    initializeAuth,
    updateUserProviderData
  } = useAuthStore();

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!initialized && !hasInitialized.current) {
      hasInitialized.current = true;
      // Add a small delay to ensure any pending token storage is complete
      setTimeout(() => {
        initializeAuth();
      }, 100);
    }
  }, [initialized, initializeAuth]);

  return {
    isAuthenticated,
    user,
    loading,
    error,
    initialized,
    login,
    logout,
    initializeAuth,
    updateUserProviderData
  };
}
